import React from 'react';
import { Row, Col } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import FeedbackCard from '../../../components/CustomerFeedBackCard';
import './index.css';
import { initialData } from "../../../redux/services/initialDataService";
import { useSelector } from 'react-redux';

const CustomerFeedback = () => {
  // const { isAuthenticated } = useAuth();

  // const { data: initialData } =
  //   useGetInitialDataQuery(undefined, { skip: !isAuthenticated });
  const initialData: initialData = useSelector(
    (state: any) => state.initialData
  );

  return (
    <div className="customer-feedback-container">
      <h1 className="mb-5 mt-3">
        Hear from the Loyal Citizens of Curry Kingdom
      </h1>
      <Row>
        {initialData?.home?.userReviews?.map(
          (userReviews: any, index: any) => (
            <Col md={6} lg={4} key={index}>
              <FeedbackCard {...userReviews} />
            </Col>
          )
        )}
      </Row>
    </div>
  );
};

export default CustomerFeedback;
